/**
 * The strings **two or more** of the three subscription surfaces render. A
 * string one surface owns lives in that surface's own `copy.ts`.
 *
 * The copy addresses the operator, never the reviewer: no design rationale, no
 * technical vocabulary, and no restatement of a mechanic the screen already
 * performs.
 */
export const sharedCopy = {
  crumbs: {
    console: 'لوحة التشغيل',
  },

  action: {
    save: 'احفظ',
    cancel: 'ألغِ',
  },

  /**
   * The line beneath a table that has no traversal control. It states how many
   * rows are shown against how many exist — **always**, even when the two
   * numbers are equal. Silent truncation is the thing forbidden, not truncation.
   */
  truncation: {
    prefix: 'معروض',
    middle: 'من',
  },

  states: {
    loading: 'جارٍ التحميل',
  },
} as const;
